import { SharedErrors } from 'web_core_library';

export class UnityError extends SharedErrors.BaseError {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, UnityError.prototype);
    this.feature = 'Unity';
    this.errorType = SharedErrors.ALERT_TYPE;
  }
}

interface IBalancingConfig {
  // max difficulty level
  maxD: number;
  // min difficulty level
  minD: number;
  // levels settings
  levels: unknown[];
}

export interface IExerciseBalancingConfig {
  exercise: {
    id: string;
    settingsClassName: string;
    exerciseConfig: IBalancingConfig;
  };
}
export type IStatState = {
  payload: any;
};

export type ITutorialState = { payload: any; lastEdit: number };

export interface IAssetCacheValue<T> {
  asset: T;
  syncTimestamp: number;
}

export interface IInitUnityPayload {
  exerciseType: 'assessment' | 'training';
  assessmentRun?: number;
  basePath?: string;
}

export interface IPrepareExercisePayload {
  exerciseId: string;
  workoutId: number;
}

export interface IStartExercisePayload {
  difficulty: number;
  duration: number;
  goal?: number;
  exerciseRun?: number;
}

export interface ILoadBalancingPayload {
  exerciseId: string;
  exerciseJsonFile: string;
}
